export default class Config {

    static getGoogleMapsApiKey() {
        return 'AIzaSyAOkoee8wpxmJg4bzEWePhSA4t-6nKsmDs';
    }

    static removePageLoader(){
        $('.page-loader').removeClass('open');
        setTimeout(function(){
            $('.page-loader').css('display', 'none');
        }, 1100);
    }

    static showPageLoader(){
        $('.page-loader').css('display', 'block')
        $('.page-loader').addClass('open')
    }
}



// WEBPACK FOOTER //
// src/scripts/Config.js